import defaultAvatar from '@/assets/images/assistant/default-avatar.svg'
import banner from '@/assets/images/contact.svg'
import { SseResponseEventEnum } from '@/constants/agent'
import { assistantState, configState } from '@/store'
import { useLocation } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import ChatItem from '../../playground/widget/ChatItem'
import Related from './Related'
import styles from './index.module.less'
import QuestionRecommend from '../QuestionRecommend'
export default function InitMessage({
  onUserSubmit,
}: {
  onUserSubmit: (text: string) => void
}) {
  const { bannerData } = useSnapshot(configState)
  const location = useLocation()
  const { curSelectAssistant, sessionMessages, historyRecord } =
    useSnapshot(assistantState)
  const openChat = {
    newChat: false,
    avatar: curSelectAssistant?.image || defaultAvatar,
    obj: 'AI',
    value: curSelectAssistant?.welcome_text || '这里是开场白',
    msgQueen: [
      {
        value: curSelectAssistant?.welcome_text || '这里是开场白',
        event: SseResponseEventEnum.answer,
      },
    ],
  }
  return (
    <div className={styles.chatItemWrap}>
      <div className={styles.chatItem}>
        {/* {historyRecord && historyRecord.length <= 0 && sessionMessages && sessionMessages.length <= 0 && */}
        <div
          className={`${styles.initMessage}`}
          // style={{ backgroundImage: `url(${bannerData?.banner || banner})` }}
        >
          <div className={styles.title}>
            <img
              src={curSelectAssistant?.image || defaultAvatar}
              alt=""
              className="w-[120px] h-[120px] rounded-[60px]"
            />
            <span className="pt-3  text-[#1C1F23] text-[20px] font-bold ">
              {curSelectAssistant?.name || '这里是名称'}
            </span>
            <div className={styles.subText}>
              {curSelectAssistant?.description || '这里是简介'}
            </div>
          </div>
        </div>
        {/* } */}
      </div>

      {!sessionMessages.length &&
      !historyRecord.length &&
      curSelectAssistant.question_recommend?.length ? (
        <div className={`${styles.chatItem} ${styles.assistantItem}`}>
          {/* <Related related={curSelectAssistant.question_recommend} onUserSubmit={onUserSubmit}/> */}
          <QuestionRecommend
            related={curSelectAssistant.question_recommend}
            onUserSubmit={onUserSubmit}
            className={'!justify-center !w-full'}
          />
        </div>
      ) : null}
      {((!sessionMessages.length && !historyRecord.length) ||
        location.pathname !== '/assistant/playground') && (
        <div className="mt-[16px]">
          <ChatItem item={openChat} />
        </div>
      )}
    </div>
  )
}
